import "./AddAlias.scss";
import React, { useState } from "react";
import {
  IonButton,
  IonInput,
  IonIcon,
  IonLabel,
  IonList,
  IonItem,
  IonToggle,
  IonDatetime,
  IonText,
  // IonNote,
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonBackButton,
  IonFooter,
  IonLoading,
  useIonViewWillEnter,
  useIonPicker,
  PickerColumn,
  IonModal,
} from "@ionic/react";
import {
  // enterOutline,
  // refreshOutline,
  chevronDownOutline,
} from "ionicons/icons";
import { useTracked } from "../../state";
import moment from "moment";
import { getAlias, setAlias, updateAlias } from "../../api/user";
import { ShowToastSuccessMessage } from "../../utils/helpers/ToastMessage";
import { useHistory, useParams } from "react-router-dom";

const AddAlias: React.FC = () => {
  const history = useHistory();
  const params: any = useParams();
  const id = params["id"];
  const [present] = useIonPicker();
  const [state, dispatch] = useTracked();
  const [aliasValue, setAliasValue] = useState<any>("");
  const [appId, setAppId] = useState<any>(0);
  const [appText, setAppText] = useState<any>("All");
  const [expiry, setExpiry] = useState<any>(moment().add(30, "days").format());
  const [burner, setBurner] = useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const Apps = {
    name: "target",
    options: [
      { text: "All", value: 0 },
      { text: "Verifier", value: 1 },
      { text: "Abaxx", value: 2 },
      { text: "Exchange", value: 3 },
      { text: "Clearing", value: 4 },
    ],
  } as PickerColumn;

  // const randomAlias = (max: number) => {
  //   let text = "";
  //   const possible =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   for (let i = 0; i < max; i++)
  //     text += possible.charAt(Math.floor(Math.random() * possible.length));
  //   setAliasValue(text);
  // };

  useIonViewWillEnter(() => {
    setAppId(0);
    setEditMode(false);
    setBurner(false);
    setAppText("All");
    setAliasValue("");
    setExpiry(moment().add(30, "days").format());

    if (id) {
      fetchAlias(id);
    }
  }, [id]);

  const fetchAlias = async (id: string) => {
    try {
      setIsLoading(true);
      const response: any = await getAlias(id);

      if (response?.status === 200 && response?.data?.id) {
        const { data } = response;
        const selectedApp = Apps.options.find(
          (app: any) => app.value === Number(data.appId)
        );

        setBurner(data.burner);
        setAliasValue(data.alias);
        if (selectedApp) {
          setAppId(selectedApp.value);
          setAppText(selectedApp.text);
        }

        if (data.expiry) {
          setExpiry(moment.unix(data.expiry).format());
        }
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  const toggleBurner = () => {
    setBurner(!burner);
  };

  const handleChange = (e: any) => {
    const { value } = e.target;
    setAliasValue(value);
  };

  const onSelect = (e: any) => {
    const { text, value } = e.target;
    setAppId(value);
    setAppText(text);
  };

  const handleSubmitBtnClick = async () => {
    try {
      if (!aliasValue) {
        showNotification("Alias is required.", "warning");
        return;
      }

      // if (aliasValue.indexOf('_') !== -1) {
      //   showNotification("Underscores are not allowed", "warning");
      //   return;
      // }

      setIsLoading(true);
      let resp: any;

      const payload: any = {
        appId,
        burner,
        authMode: state.authMode,
      }

      if (burner && expiry) {
        payload.expiry = moment(expiry).unix();
      }

      if (id) {
        resp = await updateAlias(id, {
          ...payload,
          alias: aliasValue,
        });
      } else {
        resp = await setAlias(state.identity.toLowerCase(), aliasValue, {
          ...payload,
        });
      }

      setIsLoading(false);

      if (resp?.status === 200) {
        setAppId(0);
        setBurner(false);
        setEditMode(false);
        setAppText("All");
        setAliasValue("");
        setExpiry(moment().add(30, "days").format());

        if (id) {
          ShowToastSuccessMessage("Changes of Alias successfully saved");
        } else {
          ShowToastSuccessMessage("New Alias successfully added");
        }

        history.replace("/aliases");
      } else {
        if (id) {
          const msg = resp?.message || "Update failed";
          showNotification(msg, "error");
        } else {
          const msg =
            resp?.message ||
            '"Alias already in use, input another and click Add';
          showNotification(msg, "error");
        }
      }
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      if (id) {
        showNotification("Update failed", "error");
      } else {
        showNotification(
          "Alias already in use, input another and click Add",
          "error"
        );
      }
    }
  };

  const showNotification = (content: string, type: string) => {
    dispatch({
      type: "setNotification",
      notification: {
        type,
        content,
        autoClose: 8000,
        position: "bottom-right",
      },
    });
  };

  return (
    <IonPage className="add-alias-page">
      <IonHeader className="ion-no-border" mode="ios">
        <IonToolbar mode="ios">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/aliases" text="" />
          </IonButtons>

          {!id && <IonTitle>Add Alias</IonTitle>}
          {id && !editMode && <IonTitle>View Alias</IonTitle>}
          {id && editMode && <IonTitle>Edit Alias</IonTitle>}

          {id && !editMode && (
            <IonButtons slot="end">
              <IonButton
                className="edit-btn"
                onClick={() => {
                  setEditMode(true);
                }}
              >
                Edit
              </IonButton>
            </IonButtons>
          )}
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <div className="add-alias-form">
          <IonList lines="none" mode="ios">
            <IonItem detail={false}>
              <IonLabel position="stacked">Alias</IonLabel>
              <IonInput
                name="alias"
                placeholder="Enter an Alias"
                value={aliasValue}
                maxlength={144}
                readonly={id && !editMode}
                disabled={id && !editMode}
                onIonChange={handleChange}
              />
            </IonItem>

            {/* <IonItem detail={false}>
              <IonLabel position="stacked">Alias</IonLabel>
              <IonInput
                name="alias"
                placeholder="enter an alias"
                value={aliasValue}
                onIonChange={handleChange}
              />
              <IonButton
                slot="end"
                fill="clear"
                onClick={() => {
                  randomAlias(8);
                }}
              >
                <IonNote slot="end" style={{ textTransform: "lowercase" }}>
                  ++abaxx.id
                </IonNote>
                <IonIcon slot="end" icon={refreshOutline} />
              </IonButton>
            </IonItem> */}

            <IonItem
              detail={false}
              onClick={() => {
                if (id && !editMode) {
                  // do nothing...
                } else {
                  present(
                    [Apps],
                    [
                      {
                        text: "Cancel",
                        role: "cancel",
                        handler: (e) => {},
                      },
                      {
                        text: "Confirm",
                        handler: (e) => {
                          onSelect(e);
                        },
                      },
                    ]
                  );
                }
              }}
            >
              <IonLabel position="stacked">Application</IonLabel>
              <IonInput
                readonly
                name="appId"
                placeholder="select application"
                value={appText}
                disabled={id && !editMode}
              />
              <IonIcon className="arrow-icon" icon={chevronDownOutline} />
            </IonItem>

            <IonItem detail={false} hidden={!burner} id="open-date-time">
              <IonLabel position="stacked">Expires On</IonLabel>
              <IonInput
                readonly
                name="expiry"
                value={moment(expiry).format("MMM DD YYYY")}
                disabled={id && !editMode}
              />
            </IonItem>

            <IonItem detail={false} className="burner-toggle">
              <IonLabel position="stacked">Burner *</IonLabel>
              <IonToggle
                slot="end"
                checked={burner}
                disabled={id && !editMode}
                onClick={toggleBurner}
                color="success"
                mode="md"
              />
            </IonItem>

            <IonItem lines="none">
              <IonText className="burner-hint">
                * Choose the Burner option if you want an Alias that can only be
                used once it expires.
              </IonText>
            </IonItem>
          </IonList>
        </div>
      </IonContent>

      {id && !editMode ? null : (
        <IonFooter className="ion-no-border" mode="ios">
          <IonButton
            color="danger"
            expand="block"
            shape="round"
            onClick={handleSubmitBtnClick}
          >
            Save
          </IonButton>
        </IonFooter>
      )}

      {isLoading && <IonLoading isOpen={isLoading} />}

      <IonModal trigger="open-date-time" mode="ios" className="date-time-modal">
        <IonDatetime
          mode="ios"
          max="2056-12-01"
          min={moment().add(1, 'day').format("YYYY-MM-DD")}
          disabled={id && !editMode}
          onIonChange={(e) => {
            setExpiry(e.detail.value!);
          }}
          presentation="date"
          value={expiry}
          showDefaultButtons={true}
        />
      </IonModal>
    </IonPage>
  );
};

export default AddAlias;
